// extracted by mini-css-extract-plugin
module.exports = {"portfolio":"Portfolio_portfolio__lIPiz"};